import manifest from "@/data/image-manifest.json";

export default function PortfolioImage({ src, alt, sizes = "(max-width: 600px) 90vw, (max-width: 900px) 45vw, 30vw", ...props }) {
  const image = manifest[src];
  return <img
    src={image?.variants.at(-1).src || src}
    srcSet={image?.variants.map(item => `${item.src} ${item.width}w`).join(", ")}
    sizes={image ? sizes : undefined}
    width={image?.width}
    height={image?.height}
    alt={alt}
    loading="lazy"
    decoding="async"
    {...props}
  />;
}
